import React from 'react';
import PropTypes from 'prop-types';
import { quoteFormSelector } from 'ctm-selectors';
import { Checkbox, ModalButton, withRules } from 'ctm-components';
import { connect } from 'react-redux';
import { CallCentreHoursModal } from './call_centre_hours_dialog';
import { TrustedPartnersModal } from './trusted_partners_dialog';

/**
 * This is opt-in phone component
 * @desc - a checkbox with opt-in text and opening hours modal button with opt-in text
 * @param {Object} props Component props
 * @return {Node} Slide Component
 */
const _OptinPhone = ({ dispatch, value }) => {
    const handleOpeningHoursDialogClose = () => {
        dispatch({
            type: 'SET_RESULTS_CONFIG_VALUE',
            key: 'helpers.callCentreHours',
            value: { open: false }
        });
    };

    const showOpeningHoursDialog = () => {
        dispatch({
            type: 'SET_RESULTS_CONFIG_VALUE',
            key: 'helpers.callCentreHours',
            value: { open: true }
        });
    };

    const handleTrustedPartnersDialogClose = () => {
        dispatch({
            type: 'SET_RESULTS_CONFIG_VALUE',
            key: 'helpers.trustedPartners',
            value: { open: false }
        });
    };

    const showTrustedPartnersDialog = () => {
        dispatch({
            type: 'SET_RESULTS_CONFIG_VALUE',
            key: 'helpers.trustedPartners',
            value: { open: true }
        });
    };

    /**
     * Render a ModalButton for opening the call centre times modal
     * @returns {Node} - The ModalButton
     */
    const renderOpeningHoursModalButton = () => {
        const contentProps = {
            label: 'opening hours'
        };

        const elementProps = {
            'data-id': 'callCentreHoursOpen',
            href: 'javascript:;',
            tagName: 'a'
        };

        return (
            <ModalButton contentProps={contentProps} elementProps={elementProps} onClickFunction={showOpeningHoursDialog} />
        );
    };

    /**
     * Render a ModalButton for Trusted Partners modal
     * @returns {Node} - The ModalButton
     */
    const renderTrustedPartnersModalButton = () => {
        const contentProps = {
            label: 'Trusted Partners'
        };

        const elementProps = {
            'data-id': 'trustedPartnersOpen',
            href: 'javascript:;',
            tagName: 'a'
        };

        return (
            <ModalButton contentProps={contentProps} elementProps={elementProps} onClickFunction={showTrustedPartnersDialog} />
        );
    };

    const renderLabel = () => {
        return (
            <>
                {'I invite Compare the Market or its '}
                {renderTrustedPartnersModalButton()}
                {' to call me during the call centre '}
                {renderOpeningHoursModalButton()}
                {' to discuss the potential purchase of a car insurance policy.'}
            </>
        );
    };
    const checkedActions = [
        {
            type: 'SET_FORM_VALUE',
            identifier: 'applicant.optInPhone',
            value: 'Y',
            stateKey: 'vertical.quote'
        }
    ];
    const uncheckedActions = [
        {
            type: 'SET_FORM_VALUE',
            identifier: 'applicant.optInPhone',
            value: 'N',
            stateKey: 'vertical.quote'
        }
    ];
    const schema = {
        stateKey: 'vertical.quote',
        field: {
            type: 'checkbox',
            UIComponent: 'checkbox_medium_rounded',
            labelEl: renderLabel(),
            variant: 'small_text',
            default: false,
            value: 'Y'
        },
        identifier: 'applicant.optInPhone',
        eventProps: {
            onChange: {
                checked: {
                    actions: checkedActions
                },
                unchecked: {
                    actions: uncheckedActions
                }
            }
        }
    };

    return (
        <>
            <TrustedPartnersModal closeModal={handleTrustedPartnersDialogClose} />
            <CallCentreHoursModal closeModal={handleOpeningHoursDialogClose} centres={['Car', 'Health']} />
            <Checkbox
                schema={schema}
                value={value}
                dispatch={dispatch}
                key={schema.identifier}
            />
        </>
    );
};

_OptinPhone.propTypes = {
    dispatch: PropTypes.func.isRequired,
    stateProps: PropTypes.shape({
        isOpen: PropTypes.bool
    }),
    value: PropTypes.string
};

_OptinPhone.defaultProps = {
    value: 'N'
};

/**
 * mapStateToProps - sets up the rules required by this component
 * @param {Object} state - Redux store state.
 * @return {Object} - The state attributes to add to props.
 */
const mapStateToProps = (state) => {
    const form = quoteFormSelector(state);
    const value = form.getIn(['applicant', 'optInPhone']);
    return {
        value
    };
};

const OptinPhone = withRules(connect(mapStateToProps)(_OptinPhone));

export { _OptinPhone, OptinPhone };
